/**
 * The Spec Sheet Rule as a block.
 *
 * A horizontal band of measured values under a hairline: label above value,
 * mono, on a common baseline — the back page of a datasheet. Never a grid of
 * cards, and never an icon beside a number.
 */

import type { BlockRenderer } from '@remidus/web-core'

import { specList } from './prose'

export const renderSpecband: BlockRenderer = (block) => {
  const data = (block.data ?? {}) as {
    heading?: string
    items?: { label?: string; value?: string }[]
  }
  const specs = specList(data.items, 'items')
  if (!specs) return null

  const band = document.createElement('section')
  band.className = 'skin-stage skin-stage--specband'

  if (data.heading) {
    const heading = document.createElement('p')
    heading.className = 'skin-kicker'
    heading.textContent = data.heading
    heading.dataset.remField = 'heading'
    band.append(heading)
  }
  band.append(specs)
  return band
}
